module.exports = __webpack_public_path__ + "components/flag/static/square/aq-5aea92ee9e62853ede024a97bd23103e.svg";